import { EFormVariant } from 'src/typings/base-types';
import { SWITCHER_ICON_SIZES } from 'src/constants/application';
import { TFieldsTemplateUnion } from 'src/utils/assetsFields/assetsFields.types';

export type TStorageSCMArgs = {
  isLibrary: boolean;
};

export const StorageSCM = ({ isLibrary }: TStorageSCMArgs): TFieldsTemplateUnion[] => {
  return [
    {
      name: 'libraryUUID',
      formView: EFormVariant.Express,
    },
    {
      name: 'name',
      type: 'text',
      label: 'Asset Name',
      formView: EFormVariant.Express,
    },
    {
      name: 'geoTagLocation',
      type: 'location',
      label: 'Location',
      tooltipText: 'Parent market already has location',
      EXCLUDE: isLibrary,
      formView: EFormVariant.Advanced,
    },
    {
      name: 'batteryCapacityKwh',
      type: 'number',
      label: 'Battery Capacity',
      unit: 'kWh',
      formView: EFormVariant.Advanced,
    },
    {
      name: 'initialSoc',
      type: 'number',
      label: 'Initial Capacity',
      unit: '%',
      inlineAlign: 'left',
      fullWidthErr: true,
      disabled: false,
      formView: EFormVariant.Advanced,
    },
    {
      name: 'initialkWh',
      type: 'number',
      unit: 'kWh',
      inlineAlign: 'right',
      disabled: true,
      formView: EFormVariant.Advanced,
    },
    {
      name: 'minAllowedSoc',
      type: 'number',
      label: 'Minimum State of Charge',
      unit: '%',
      formView: EFormVariant.Advanced,
    },
    {
      name: 'maxAbsBatteryPowerKw',
      type: 'number',
      label: 'Max Power Rating',
      unit: 'kW',
      formView: EFormVariant.Advanced,
    },
    {
      name: 'allowExternalConnection',
      type: 'switcher',
      options: [
        { icon: 'close', iconSize: SWITCHER_ICON_SIZES.close, value: false },
        { icon: 'check-mark', iconSize: SWITCHER_ICON_SIZES.tick, value: true },
      ],
      label: 'API Open',
      formView: EFormVariant.CanaryNetwork,
      disabled: true,
    },
  ];
};
